import { Rate as AntdRate } from "antd";
import { CMP_PREFIX } from "@/base/constant";
import { cx } from "antd-style";
import type { GetProps } from "antd";

type SizeType = "default" | "large";
export type RateProps = Partial<GetProps<typeof AntdRate> & { size: SizeType }>;

export const ratePrefixCls = `${CMP_PREFIX}-rate`;

export const Rate = ({ size = "default", className, ...props }: RateProps) => {
  return (
    <AntdRate
      className={cx(`${ratePrefixCls}-size-${size}`, className)}
      {...props}
    />
  );
};
